import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Calendar, Wrench, TrendingUp, MessageSquare, FileText, Settings, Mail, Bot, Award, Lightbulb, Instagram } from 'lucide-react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { useLanguage } from '@/context/LanguageContext';

export default function Dashboard() {
  const navigate = useNavigate();
  const { lang, t } = useLanguage();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) navigate('/login');
  }, [navigate]);

  const dashboardCards = [
    { title: t('dashboard', 'bookings'), icon: Calendar, path: '/dashboard/bookings', color: 'from-blue-500 to-blue-600', desc: t('dashboard', 'bookingsDesc') },
    { title: t('dashboard', 'services'), icon: Wrench, path: '/dashboard/services', color: 'from-purple-500 to-purple-600', desc: t('dashboard', 'servicesDesc') },
    { title: t('dashboard', 'campaigns'), icon: MessageSquare, path: '/dashboard/campaigns', color: 'from-green-500 to-green-600', desc: t('dashboard', 'campaignsDesc') },
    { title: t('dashboard', 'tips'), icon: FileText, path: '/dashboard/blog', color: 'from-orange-500 to-orange-600', desc: t('dashboard', 'tipsDesc') },
    { title: t('dashboard', 'analytics'), icon: TrendingUp, path: '/dashboard/analytics', color: 'from-red-500 to-red-600', desc: t('dashboard', 'analyticsDesc') },
    { title: t('dashboard', 'siteContent'), icon: Settings, path: '/dashboard/site-settings', color: 'from-indigo-500 to-indigo-600', desc: t('dashboard', 'siteContentDesc') },
    { title: t('dashboard', 'messages'), icon: Mail, path: '/dashboard/messages', color: 'from-teal-500 to-teal-600', desc: t('dashboard', 'messagesDesc') },
    { title: 'AI Co-Pilot', icon: Bot, path: '/dashboard/copilot', color: 'from-cyan-500 to-cyan-600', desc: lang === 'en' ? 'Your business AI assistant' : 'Il tuo assistente AI business' },
    { title: lang === 'en' ? 'Events & Awards' : 'Eventi e Riconoscimenti', icon: Award, path: '/dashboard/events', color: 'from-amber-500 to-amber-600', desc: lang === 'en' ? 'Manage events from Instagram' : 'Gestisci eventi da Instagram' },
    { title: 'Consigli', icon: Lightbulb, path: '/dashboard/consigli', color: 'from-teal-500 to-teal-600', desc: lang === 'en' ? 'Manage tips from Instagram' : 'Gestisci consigli da Instagram' },
    { title: 'Instagram', icon: Instagram, path: '/dashboard/instagram', color: 'from-pink-500 to-rose-600', desc: lang === 'en' ? 'Manage Instagram token & sync' : 'Gestisci token Instagram e sincronizzazione' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="pt-32 pb-16 px-4 sm:px-6 lg:px-8" data-testid="dashboard-page">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Space Grotesk' }}>{t('dashboard', 'title')}</h1>
            <p className="text-xl text-gray-600">{t('dashboard', 'welcome')}</p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {dashboardCards.map((card, idx) => (
              <Link key={idx} to={card.path} className="group bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-[#0066b2] transition-all duration-300 hover:shadow-2xl transform hover:-translate-y-2" data-testid={`dashboard-card-${idx}`}>
                <div className={`w-16 h-16 bg-gradient-to-br ${card.color} rounded-2xl flex items-center justify-center mb-6 transform group-hover:rotate-6 transition-transform shadow-lg`}>
                  <card.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Space Grotesk' }}>{card.title}</h3>
                <p className="text-gray-600">{card.desc}</p>
                <div className="mt-4 text-[#0066b2] font-medium group-hover:underline">{t('dashboard', 'goToSection')}</div>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
